import { IdogcamViewerLaunch } from '../model/IdogcamModel';

export class IdogcamPopupBlockedError extends Error {
    constructor() {
        super('The browser blocked the iDogCam window');
        this.name = 'IdogcamPopupBlockedError';
    }
}

const writeLoadingPage = (viewerDocument: Document) => {
    viewerDocument.title = 'iDogCam';
    viewerDocument.body.style.fontFamily = 'Poppins, sans-serif';
    viewerDocument.body.textContent = 'Loading camera...';
};

// The form lives inside the new (same-origin, about:blank) window and navigates that window,
// so we never depend on looking the window up by name.
const submitViewerForm = (viewerDocument: Document, launch: IdogcamViewerLaunch) => {
    const form = viewerDocument.createElement('form');
    form.method = launch.method || 'POST';
    form.action = launch.viewerUrl;

    const input = viewerDocument.createElement('input');
    input.type = 'hidden';
    input.name = launch.authParam;
    input.value = launch.auth;
    form.appendChild(input);

    viewerDocument.body.appendChild(form);
    form.submit();
};

// iDogCam's viewer only accepts the camera auth as a POSTed form field, so it can't be a plain link.
// The window must be opened synchronously inside the click handler: opening it after the
// await would be treated as an unsolicited popup and blocked (Safari always blocks it).
// Call it directly from a user event handler.
export const openIdogcamViewer = async (fetchLaunch: () => Promise<IdogcamViewerLaunch>): Promise<void> => {
    const viewerWindow = window.open('', '_blank');

    if (!viewerWindow) {
        throw new IdogcamPopupBlockedError();
    }

    // The viewer is a third-party page: cut its access back to Cuddles (reverse tabnabbing).
    viewerWindow.opener = null;
    writeLoadingPage(viewerWindow.document);

    try {
        const launch = await fetchLaunch();
        submitViewerForm(viewerWindow.document, launch);
    } catch (error) {
        viewerWindow.close();
        throw error;
    }
};
